export enum FeatureFlag {
  CanadianAdaptations = 'Canadian Adaptations',
  CognitoAuth = 'Cognito Auth',
  CognitoSync = 'Cognito Sync',
  DashboardDesktopFrame = 'Dashboard Desktop Frame',
  PointsAuditLog = 'Points Audit Log',
  Test = 'Test Feature Flag',
}
